// Theme constants for consistent styling across the application
export const theme = {
  colors: {
    brandBlue: "#17428C",
    textDark: "#1F2937",
    border: "#E5E7EB",
    white: "#FFFFFF",
    background: "#F9FAFB"
  },
  spacing: {
    container: "max-w-7xl",
    padding: "px-6 py-6",
    sectionPadding: "py-12",
    heroPadding: "py-12 md:py-16"
  },
  shadows: {
    card: "0 4px 12px rgba(0,0,0,0.05)",
    large: "0 6px 16px rgba(0,0,0,0.08)"
  }
};

// Destructured exports for easy importing
export const { brandBlue, textDark, border, white, background } = theme.colors;
export const { container, padding, sectionPadding, heroPadding } = theme.spacing;
export const { card, large } = theme.shadows;
